<script>
  import curd from './Base/Crud'
  export default {
    mixins: [curd],
    name: 'InfoBusChange',
    props: ['defaultParams'],
    data() {
      return {
        url: '/info/bus/change',
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: true, // 增加按钮显隐
          addBtnText:'添加更改', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: true, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '变更名称',
              prop: 'title',
              span: 24,
              rules: [{
                type: 'string', required: true, message: '输入不正确', trigger: 'blur'
              }]
            }, {
              label: '变更内容',
              prop: 'content',
              overHidden: true,
              type: 'textarea',
              span: 24,
              rules: [{
                type: 'string', required: true, message: '输入不正确', trigger: 'blur'
              }]
            }, {
              label: '发布时间',
              display: false,
              prop: 'created_at'
            }
          ]
        }
      }
    }
  }
</script>
